import { useEffect, useCallback, useState, useMemo } from 'react';
import Table from './Table';
import AddLog from './AddLog';
import adminAPI from '../../API/adminAPI';

export default function LogTableDisplay(props) {
    const { id, qrType, qrData, qrObj, logs, editLogEntry, setEditLogEntry, selectedLog, setSelectedLog, authenticatedUser, isCheckingAuth, deletedToggle, setDeletedToggle, onShowAddLogChange, externalShowAddLog, externalSetShowAddLog } = props;
    const [config, setConfig] = useState({});
    const [internalShowAddLog, setInternalShowAddLog] = useState(false);
    
    // Use external state if provided, otherwise use internal state
    const showAddLog = externalShowAddLog !== undefined ? externalShowAddLog : internalShowAddLog;
    const setShowAddLog = externalSetShowAddLog || setInternalShowAddLog;
    
    const typeHeader = useMemo(() => qrType === 'tracker' ? 'Tracker' : 'Survey', [qrType]);
    const dataType = useMemo(() => qrType === 'tracker' ? 'columns' : 'questions', [qrType]);
    const configTypes = useMemo(() => (
        config?.field_types?.fields ||
        config?.fields ||
        config?.[dataType] ||
        {}
    ), [config?.field_types?.fields, config?.fields, config, dataType]);
    const fields = useMemo(() => (qrData?.fields?.filter(field => !field?.archived) || qrData?.[dataType]?.filter(field => !field?.archived) || []), [qrType, qrData?.fields, qrData, dataType]);
    const filteredFields = useMemo(() => {
        // Don't filter until config is loaded to prevent flash of unfiltered headers
        if (!configTypes || Object.keys(configTypes).length === 0) return [];
        return fields.filter(field => !configTypes?.[field?.type]?.readOnly);
    }, [fields, configTypes]);

    const handleGetConfig = useCallback(async () => {
        try {
            const { data } = await adminAPI.getConfigDocs();
            if (data) {
                setConfig(data);
            };
        } catch (err) {
            console.error('Error retrieving configDocs:', err);
        };
    }, []);

    useEffect(() => {
        if (!configTypes || !configTypes?.hasOwnProperty('date')) handleGetConfig();
    }, [configTypes]);

    useEffect(() => {
        // Only notify parent about showAddLog state changes from user interaction,
        // not about the default rendering behavior for unauthenticated users
        if (externalSetShowAddLog) {
            onShowAddLogChange?.(showAddLog);
        }
    }, [showAddLog, externalSetShowAddLog, onShowAddLogChange]);

    if (!qrData) return (<div>{typeHeader} not found</div>);

    // Don't show AddLog for unauthenticated users while still checking auth to prevent flash
    const shouldShowAddLog = showAddLog || (qrType === 'survey' && !authenticatedUser && !isCheckingAuth);

    if (shouldShowAddLog) {
        return (
            <AddLog
                id={id}
                fields={fields}
                setShowAddLog={setShowAddLog}
                authenticatedUser={authenticatedUser}
                qrType={qrType}
                qrData={qrData}
                dataType={dataType}
                configTypes={configTypes}
            />
        );
    } else {
        return (
            <Table
                id={id}
                fields={filteredFields}
                allFields={fields}
                logs={logs}
                qrObj={qrObj}
                qrData={qrData}
                setShowAddLog={setShowAddLog}
                editLogEntry={editLogEntry}
                setEditLogEntry={setEditLogEntry}
                selectedLog={selectedLog}
                setSelectedLog={setSelectedLog}
                authenticatedUser={authenticatedUser}
                deletedToggle={deletedToggle}
                setDeletedToggle={setDeletedToggle}
                qrType={qrType}
                dataType={dataType}
                configTypes={configTypes}
            />
        );
    };
};
